import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { EnvProvider } from "./lib/env";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <EnvProvider>
        <App />
      </EnvProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
